import axios from 'axios'
import store from '@/store/index.js'
// import baseURL from './baseUrl'
import Message from "../libs/ele/src"
import { setTimeout } from 'timers'
import router from 'vue-router'

const instance = axios.create({
  baseURL: "/",
  timeout: 10000
})

// instance.defaults.timeout = 30000
// instance.defaults.baseURL = "/"
instance.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'


// const CancelToken = axios.CancelToken
instance.interceptors.request.use(function (config) {
  // config.cancelToken = new CancelToken((cancel) => {
  //   store.state.axiosPromiseCancel.push(cancel)
  // })
  // let token = sessionStorage.getItem('token')
  // if (token) {
  config.headers.common['Authorization'] = "Bearer" + " " + store.state.auth.token
  // }
  return config
}, function (error) {
  return Promise.resolve(error)
})

instance.interceptors.response.use(
  response => {
    return response
  },
  error => {
    // if (instance.isCancel(error)) {
    //   return new Promise(() => { })
    // }
    console.log("responseerr", error)
    if (!error.response) {
      Message({
        type: "error",
        message: '请求超时!'
      })
    }
    else {
      const status = error.response.status;
      switch (status) {
        case 400:
          Message.error(`请求错误`)
          break
        case 401:
          Message.error(`身份验证过期,请重新登录`)
          setTimeout(() => {
            router.replace('/login')
            store.commit("logout")
          }, 100)
          break
        case 403:
          Message({
            type: "error",
            message: '权限不足,无法操作',
            duration: 3000
          })
          break
        case 404:
          Message.error(
            "请求错误,未找到该资源"
          )
          break
        case 500:
          Message.error(`服务端错误:${error.response}`)
          break
        default:
          Message.error(`请求超时:${error.response}`)
      }
      return status >= 200 && status < 300
    }
    return Promise.reject(error)
  }
)
instance.defaults.transformRequest = [function (data) {
  let ret = ''
  for (let it in data) {
    ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
  }
  return ret
}]


export function get(url, params) {
  return new Promise((resolve, reject) => {
    instance.get(url, { params: params }).then(
      res => {
        resolve(res.data)
      }
    ).catch(
      err => {
        reject(err.data)
      }
    )
  })
}

export function post(url, params, headObj) {
  return new Promise((resolve, reject) => {
    instance.post(url, params, { headers: headObj }).then(
      res => {
        resolve(res.data)
      }
    ).catch(
      err => {
        reject(err.data)
      }
    )
  })
}

export function delone(url, params) {
  return new Promise((resolve, reject) => {
    instance.delete(url, { params: params }).then(
      res => {
        resolve(res.data)
      }
    ).catch(
      err => {
        reject(err.data)
      }
    )
  })
}
export function put(url, params) {
  return new Promise((resolve, reject) => {
    instance.put(url, params).then(
      res => {
        resolve(res.data)
      }
    ).catch(
      err => {
        reject(err.data)
      }
    )
  })
}

export default instance
